import { ServiceContext } from 'utilities/service.utils';

const MapDataService = new ServiceContext(
  process.env.REACT_APP_MAP_DATA_SERVICE_NAME,
  async (headers: any) => {
    return headers;
  }
);

export default MapDataService;
